export const RedirectErrors: {[x: string]: string} = {
  internal_server_error: 'erro inesperado ao logar',
  user_email_does_not_exists: 'usuário não cadastrado no Brain',
  user_is_deleted: 'usuário não tem permissão para logar',
}
